import React from 'react'
import "./NotVerified.css"
import { useStateValue } from "./StateProvider";
import { useHistory } from "react-router-dom";

function NotVerified() {
    const history = useHistory();
    const [{ user }, dispatch] = useStateValue();   

const verifyEmail = (event) => {
    user.sendEmailVerification().then(function() {
        // Email sent.
        alert("Verification email sent to " + user.email)
      }).catch(function(error) {
        // An error happened.
        alert(error)
      });
    }
    const backLogin = (event) => {
        history.push("/login") 

    }

    return (
        <div  className="notverified">
            <h1 className="notyetverified">E-mail Not Yet Verified</h1>
            <h2 className="checkemail">Check your Inbox for e-mail link</h2>
            <button onClick={verifyEmail} className="resend__button">Resend E-Mail Verification</button>
            <button onClick={backLogin} className="resend__button">Back to Login</button>

        </div>
    )
}

export default NotVerified
